/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import {View} from 'react-native';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {HealthProfileTestIds} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {enableLayoutAnimation} from '/util/animation.util';
import {safeLayoutAnimation} from '/util/animation.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './HealthProfile.style';
import WeightTracker from './WeightTracker';

interface HealthProfileProps {
  clientId: '';
  weightGraphData: {};
  bodyMeasurementsData: {};
  fetchWeightGraph: {};
  fetchBodyMeasurements: {};
  mwlData: {};
}

export const HealthProfile: React.FC<HealthProfileProps> = ({
  fetchWeightGraph = {},
  fetchBodyMeasurements = {},
  clientId = '',
  weightGraphData = {},
  bodyMeasurementsData = {},
  mwlData = {},
}: any) => {
  const {ts, tt} = useTranslation('clienthealthprofile');
  const [trackerExpanded, setTrackerExpanded] = useState<boolean>(true);

  useEffect(() => {
    fetchWeightGraph(mwlData, clientId);
    fetchBodyMeasurements(mwlData, clientId);
    enableLayoutAnimation();
  }, []);

  const toggleExpand = () => {
    safeLayoutAnimation();
    setTrackerExpanded(prevExpanded => !prevExpanded);
  };
  const weightGraph = weightGraphData[clientId];
  const inchesLost = bodyMeasurementsData[clientId];

  return (
    <View
      style={styles.container}
      {...testProperties(HealthProfileTestIds.root, true)}>
      <View style={styles.header}>
        <Text
          variant="heading"
          style={styles.headerText}
          {...testProperties(HealthProfileTestIds.header)}>
          {tt('heading', 'Client health profile')}
        </Text>
        <TouchableOpacity
          onPress={toggleExpand}
          style={styles.showHideButtonContainer}>
          <Text
            isBold
            variant="body"
            disabled
            style={styles.showHideButton}
            {...testProperties(
              trackerExpanded
                ? HealthProfileTestIds.hideBtn
                : HealthProfileTestIds.showBtn,
            )}>
            {trackerExpanded ? ts('hide', 'Hide') : ts('show', 'Show')}
          </Text>
          <Icon
            name={trackerExpanded ? 'chevron-up' : 'chevron-down'}
            style={styles.icon}
          />
        </TouchableOpacity>
      </View>
      {trackerExpanded && (
        <WeightTracker
          hasUpdates={true}
          clientId={clientId}
          weightGraph={weightGraph}
          inchesLost={inchesLost}
        />
      )}
    </View>
  );
};

export default HealthProfile;
